// extracted by mini-css-extract-plugin
export default {"card":"portfolio_card__ZYlJk","btn":"portfolio_btn__pPfQZ"};